import { colors } from '@checkatrade/web-ui/themes';

const SvgComponent = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    fill="none"
    viewBox="0 0 96 96"
    className={className}
  >
    <mask
      id="a"
      width="96"
      height="96"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      className={className}
    >
      <path fill={colors.secondary[100]} d="M0 0h96v96H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill={colors.secondary[100]}
        d="M4 80.715V69.427c0-2.285.583-4.385 1.75-6.3s2.717-3.376 4.65-4.384c4.133-2.083 8.333-3.645 12.6-4.686a54.624 54.624 0 0 1 13-1.563c2.133 0 4.283.118 6.45.353s4.317.622 6.45 1.16a23.748 23.748 0 0 0-2.25 3.577 22.956 22.956 0 0 0-1.55 3.88 36.437 36.437 0 0 0-4.55-.705 50.962 50.962 0 0 0-4.55-.202c-3.733 0-7.433.454-11.1 1.361S17.6 64.186 14 66c-.6.336-1.083.806-1.45 1.41a3.812 3.812 0 0 0-.55 2.017v3.225h32.3c.267 1.478.633 2.89 1.1 4.233a20.06 20.06 0 0 0 1.8 3.83H4Zm32-32.252c-4.4 0-8.167-1.58-11.3-4.737-3.133-3.158-4.7-6.954-4.7-11.39 0-4.434 1.567-8.23 4.7-11.388 3.133-3.158 6.9-4.737 11.3-4.737s8.167 1.579 11.3 4.737c3.133 3.158 4.7 6.954 4.7 11.389s-1.567 8.23-4.7 11.389c-3.133 3.158-6.9 4.737-11.3 4.737Zm40-16.126c0 4.435-1.567 8.23-4.7 11.389-3.133 3.158-6.9 4.737-11.3 4.737-.733 0-1.667-.084-2.8-.252-1.133-.168-2.067-.353-2.8-.554a24.018 24.018 0 0 0 4.15-7.156A23.402 23.402 0 0 0 60 32.337c0-2.822-.483-5.543-1.45-8.164a24.02 24.02 0 0 0-4.15-7.156 12.082 12.082 0 0 1 2.8-.655c.933-.1 1.867-.151 2.8-.151 4.4 0 8.167 1.579 11.3 4.737 3.133 3.158 4.7 6.954 4.7 11.389ZM36 40.4c2.2 0 4.083-.79 5.65-2.369 1.567-1.579 2.35-3.477 2.35-5.694s-.783-4.116-2.35-5.695c-1.567-1.579-3.45-2.368-5.65-2.368s-4.083.79-5.65 2.368C28.783 28.222 28 30.12 28 32.337s.783 4.115 2.35 5.694C31.917 39.611 33.8 40.4 36 40.4Zm32 36.283c2.267 0 4.15-.672 5.65-2.015 1.5-1.344 2.283-3.36 2.35-6.048.067-2.284-.683-4.2-2.25-5.745s-3.483-2.318-5.75-2.318-4.167.773-5.7 2.319c-1.533 1.545-2.3 3.46-2.3 5.744 0 2.285.767 4.2 2.3 5.745 1.533 1.546 3.433 2.318 5.7 2.318Zm0 8.063c-4.4 0-8.167-1.579-11.3-4.737-3.133-3.158-4.7-6.954-4.7-11.389 0-4.434 1.567-8.23 4.7-11.389 3.133-3.158 6.9-4.737 11.3-4.737s8.167 1.58 11.3 4.737c3.133 3.158 4.7 6.955 4.7 11.39a16.98 16.98 0 0 1-.55 4.384 14.778 14.778 0 0 1-1.65 3.88L92 87.165l-5.6 5.644-10.2-10.28c-1.2.74-2.483 1.294-3.85 1.663a16.6 16.6 0 0 1-4.35.554Z"
      />
    </g>
  </svg>
);
export default SvgComponent;
